import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';
import Flickity from 'flickity';

export default class HomeTwitter {
  constructor(section) {
    this.$el = $(section.el);
    this.settings = section.data;
    this.$tweetContainer = this.$el.find('[data-twitter-tweets]');
    this.$slideshow = this.$el.find('[data-twitter-tweets]');

    this.username = this.settings.username;
    this.retweets = this.settings.retweets;
    this.$template = $(this.settings.template);

    this.renderTweets = this._renderTweets.bind(this);

    if (!this.username) {
      this._twitterWarning();
      return;
    }

    this._fetchTweets();
  }

  _fetchTweets() {
    twitterFetcher.fetch({
      profile: { screenName: this.username },
      maxTweets: 5,
      enableLinks: true,
      showImages: false,
      showUser: false,
      showTime: false,
      showRetweet: this.retweets,
      customCallback: this.renderTweets,
      showInteraction: false,
      useEmoji: true,
    });
  }

  _renderTweets(tweets) {
    if (!tweets.length) {
      this._twitterWarning();
      return;
    }

    const tweetsArray = [];
    tweets.forEach((tweet) => {
      const $tweet = $(tweet);
      const $template = this.$template.clone();

      $template
        .find('.twitter-tweet')
        .html($tweet);

      tweetsArray.push($template);
    });

    this.$tweetContainer.append(tweetsArray);

    this._initFlickity();
  }

  _initFlickity() {
    this.flickity = new Flickity(this.$slideshow[0], {
      accessibility: true,
      adaptiveHeight: false,
      autoPlay: false,
      pageDots: false,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.15,
    });
  }

  _twitterWarning() {
    console.warn('No tweets to display. Most probable cause is an incorrectly entered username.');
    this.$tweetContainer.remove();
  }
}
